export default [
  /* AXT */
  {
    id: "CRE",
    color: 'yellowLight',
    summary: '<span class="font-weight-bold">Recibido en nuestra</span> <span class="blue-200--text font-weight-bold">plataforma</span>',
    icon: 'mdi-monitor'
  },
  {
    id: "MRT",
    color: 'yellowLight',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">reprocesado</span> manualmente',
    icon: 'mdi-gesture-double-tap'
  },
  {
    id: "ART",
    color: 'yellowLight',
    summary: '<span class="font-weight-bold">Procesando</span>',
    icon: 'mdi-sync'
  },
  {
    id: "APR",
    color: 'lightBlue',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">aprobado</span> por la agencia',
    icon: 'mdi-file-check'
  },
  {
    id: "OBS",
    color: 'purpleLight',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">aprobado con observaciones</span> por la agencia',
    icon: 'mdi-file-eye'
  },
  {
    id: "SNT",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Enviado a la</span> <span class="blue-200--text font-weight-bold">agencia</span>',
    icon: 'mdi-bank'
  },
  {
    id: "FAI",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Pendiente</span>',
    icon: 'mdi-clock'
  },
  {
    id: "REJ",
    color: 'redLight',
    summary: '<span class="font-weight-bold">Rechazado por la</span> <span class="blue-200--text font-weight-bold">agencia</span>',
    icon: 'mdi-bank-remove'
  },
  {
    id: "ARJ",
    color: 'redLight',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">rechazado</span> <span class="font-weight-bold">en SII</span>',
    icon: 'mdi-bank-remove'
  },
  {
    id: "AAP",
    color: 'lightBlue',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">aprobado</span> <span class="font-weight-bold">en SII</span>',
    icon: 'mdi-bank-check'
  },
  {
    id: "DUP",
    color: 'redLight',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">rechazado por duplicidad</span> en la <span class="blue-200--text font-weight-bold">agencia</span>',
    icon: 'mdi-file-remove-outline'
  },
  {
    id: "VOI",
    color: 'greyMedium',
    summary: '<span class="font-weight-bold">Anulado</span>',
    icon: 'mdi-file-cancel-outline'
  },
  {
    id: "EST",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Enviado por mail</span>',
    icon: 'mdi-email-arrow-right'
  },
  {
    id: "INV",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">invalidado</span>',
    icon: 'mdi-file-remove-outline'
  },
  {
    id: "PRE",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">por confirmar</span>',
    icon: 'mdi-file-outline'
  },
  {
    id: "CSM",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Distribucion</span> normativa <span class="blue-200--text font-weight-bold">enviada</span>',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ERJ",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Distribucion</span> <span class="blue-200--text font-weight-bold">rechazado</span>',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RNO",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">no recibido</span> por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROK",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Distribucion</span> <span class="blue-200--text font-weight-bold">recibido</span> por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RAP",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">aprobado</span> por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ROB",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">aprobado con discrepancias</span> por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "RRJ",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento</span> <span class="blue-200--text font-weight-bold">rechazado</span> por el receptor',
    icon: 'mdi-calendar-blank'
  },
  {
    id: "ENS",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Email</span> <span class="blue-200--text font-weight-bold">no enviado</span>',
    icon: 'mdi-email-remove-outline'
  },
  {
    id: "EBO",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Email</span> <span class="blue-200--text font-weight-bold">ha rebotado</span>',
    icon: 'mdi-email-arrow-left-outline'
  },
  {
    id: "DCA",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">aprobado</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCP",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">enviado</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCE",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">con error</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCC",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">creado</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCN",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">anulado</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "DCR",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span> <span class="blue-200--text font-weight-bold">rechazado</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  },
  {
    id: "CTP",
    color: 'blueGreyLighten',
    summary: '<span class="font-weight-bold">Documento cedido</span>',
    icon: 'mdi-file-arrow-left-right-outline'
  }
  /* END AXT */
]
